import axios from 'axios';
import { APP_SETTINGS } from '../../config';

export function getAllExpenses() {
    return axios.post(APP_SETTINGS.API_PATH.EXPENSE.getExpense, {
        "itemDescription": "",
        "expenseTypeId": 0,
        "paidBy": "",
        "paidTo": "",
        "paymentTypeId": 0,
        "statusId": 0,
        "fromDate": "",
        "toDate": ""
    })
}
export function getFilteredExpenses(data) {
    var finalData = {
        "itemDescription": data.itemDescription ? data.itemDescription : "",
        "expenseTypeId": data.expenseTypeId ? data.expenseTypeId : 0,
        "paidBy": "",
        "paidTo": "",
        "paymentTypeId": data.paymentTypeId ? data.paymentTypeId : 0,
        "statusId": data.statusId ? data.statusId : 0,
        "fromDate": data.fromDate ? data.fromDate : "",
        "toDate": data.toDate ? data.toDate : ""
    }
    return axios.post(APP_SETTINGS.API_PATH.EXPENSE.getExpense, finalData);
}
export function addNewExpense(expenseData) {
    return axios.post(APP_SETTINGS.API_PATH.EXPENSE.addExpense, expenseData);
}

export function addNewExpenseList(expenseData) {
    return axios.post(APP_SETTINGS.API_PATH.EXPENSE.addExpenseList, expenseData);
}
export function removeExpense(expenseId) {
    var data = {
        "expenseId": expenseId
    }
    return axios.post(APP_SETTINGS.API_PATH.EXPENSE.removeExpense, data)
}
export function getExpenseTypes() {
    return axios.get(APP_SETTINGS.API_PATH.EXPENSE.EXPENSETYPE.getExpenseTypes)
}
export function addNewExpenseType(expenseTypeData) {
    return axios.post(APP_SETTINGS.API_PATH.EXPENSE.EXPENSETYPE.addExpenseType, expenseTypeData)
}
export function deleteExpenseType(expenseTypeId) {
    return axios.post(APP_SETTINGS.API_PATH.EXPENSE.EXPENSETYPE.deleteExpenseType, {
        "requestId": expenseTypeId
    })
}
export function getSubExpenseTypes() {
    return axios.get(APP_SETTINGS.API_PATH.EXPENSE.SUBEXPENSES.getSubExpenses);
}
export function addSubExpenseType(data) {
    return axios.post(APP_SETTINGS.API_PATH.EXPENSE.SUBEXPENSES.addSubExpense, data);
}
export function deleteSubExpenseType(subExpenseId) {
    return axios.post(APP_SETTINGS.API_PATH.EXPENSE.SUBEXPENSES.deleteSubExpense, { "requestId": subExpenseId });
}